import { render, staticRenderFns } from "./FoodLabels.vue?vue&type=template&id=6ae53576&scoped=true"
import script from "./FoodLabels.vue?vue&type=script&lang=js"
export * from "./FoodLabels.vue?vue&type=script&lang=js"
import style0 from "./FoodLabels.vue?vue&type=style&index=0&id=6ae53576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae53576",
  null
  
)

export default component.exports